import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import TextInput from '../text-input/index';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';
import Button from '../button/index';
import { CIRCLE_SUCCESS, CIRCLE_DANGER } from '../button/variants';
import { Tick, Warning, Cross } from '../../helpers/icon-dictionary';
import messages from './messages';
import ConfirmationMessage from '../../components/confirmation-message/index';
import { invalidCharaters } from '../../helpers/utils';

class AddStudent extends Component {
    constructor(props) {
        super(props);
        this.state = { canSubmit: false };
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
        this.getUpdatedClassrooms = this.getUpdatedClassrooms.bind(this);
    }

    componentDidMount() {
        this.getUpdatedClassrooms();
    }

    getUpdatedClassrooms = () => {
        const { intl, selectedProduct } = this.props;
        // default classes for the add student dropdown menu
        const defaultClassoomList = [{ key: '-1', value: intl.formatMessage(messages.classroomList, { product: selectedProduct.name }), selected: true }];
        this.setState({ classrooms: defaultClassoomList.concat(this.filterClassrooms(this.props.classes)) });
    }

    filterClassrooms = (classrooms) => {
        const classes = classrooms.map(item => ({
            key: item.classroomId,
            value: item.name
        }));
        return classes;
    }

    validateStudentModel = () => {
        if (this.props.student.firstName.trim() !== '' &&
            this.props.student.lastName.trim() !== '' &&
            this.props.student.yearGroup !== '-1') {
            if (this.props.isSaveInProgress) {
                this.setState({ canSubmit: false });
            } else {
                this.setState({ canSubmit: true });
            }
        } else {
            this.setState({ canSubmit: false });
        }
    }

    handleTextInputOnChange = (event) => {
        const regex = new RegExp(invalidCharaters());
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.student[field] = value;
        this.validateStudentModel(this.props.student);
        return true;
    }

    handleListOnChange = (field, value) => {
        this.props.student[field] = value;

        if (field === 'classroomId' && value !== -1) {
            this.props.getClassroomGroups(value);
        }

        if (field === 'classroomId' && value === -1) {
            this.props.student.classroomGroupId = '-1';
        }

        this.validateStudentModel(this.props.student);
    }

    handleGroupChange = (field, value) => {
        this.props.student[field] = value;
        this.validateStudentModel(this.props.student);
    }

    handleOnSubmit = () => {
        this.setState({ canSubmit: false });
        this.props.handleOnAddStudentSubmit();
    }

    handleOnCloseValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeAddStudentValidationModal();
    }


    render() {
        const confirmCp = (
            <ConfirmationMessage handleOnCloseModal={this.handleOnCloseValidationModal} icon={Warning} >
                <div>{this.props.addStudentValidationMessage}</div>
            </ConfirmationMessage>
        );

        const formCp = (
            <div className={this.props.css.addStudentComponent}>
                <div className={this.props.css.addStudentHeader}> {this.props.intl.formatMessage(messages.addStudent)} </div>
                <div className={this.props.css.firstName}><TextInput
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="firstName"
                    placeholder={this.props.intl.formatMessage(messages.firstName)}
                    value={this.props.student.firstName}
                /></div>
                <div className={this.props.css.surName}><TextInput
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="lastName"
                    placeholder={this.props.intl.formatMessage(messages.surname)}
                    value={this.props.student.lastName}
                /></div>
                <div className={`${this.props.css.surName}`}><TextInput
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="previousUsername"
                    placeholder={this.props.intl.formatMessage(messages.previousUsername)}
                    value={this.props.student.previousUsername}
                /></div>
                <div className={this.props.css.list}>
                    <DropDownList
                        css={listStyle}
                        name="yearGroup"
                        onChange={this.handleListOnChange}
                        options={this.props.yearGroups}
                        value={this.props.student.yearGroup}
                    />
                </div>
                <div className={this.props.css.list}>
                    <DropDownList
                        css={listStyle}
                        name="classroomId"
                        onChange={this.handleListOnChange}
                        optionLength={45}
                        options={this.state.classrooms}
                        value={this.props.student.classroomId}
                    />
                </div>
                <div className={this.props.css.list}>
                    <DropDownList
                        css={listStyle}
                        name="classroomGroupId"
                        onChange={this.handleListOnChange}
                        optionKey="id"
                        optionLength={45}
                        options={this.props.classroomGroups}
                        optionText="name"
                        placeholder={this.props.intl.formatMessage(messages.groupLabel)}
                        value={this.props.student.classroomGroupId}
                    />
                </div>
                <div className={this.props.css.actionButtonWrapper}><Button
                    containerClassName={this.props.css.btnDanger}
                    disabled={this.props.isSaveInProgress}
                    handleOnClick={this.props.handleOnCloseModal}
                    icon={Cross}
                    iconClassName={this.props.css.svgIconContainer}
                    variant={CIRCLE_DANGER}
                /><Button
                    containerClassName={this.props.css.btnSuccess}
                    disabled={!this.state.canSubmit}
                    handleOnClick={this.handleOnSubmit}
                    icon={Tick}
                    iconClassName={this.props.css.svgIconContainer}
                    variant={CIRCLE_SUCCESS}
                />
                </div>
            </div>
        );

        const finalContent = this.props.showAddStudentValidationModal ? confirmCp : formCp;

        return (
            finalContent
        );
    }
}
AddStudent.propTypes = {
    addStudentValidationMessage: PropTypes.string,
    classes: PropTypes.arrayOf(PropTypes.object),
    closeAddStudentValidationModal: PropTypes.func,
    css: PropTypes.object,
    handleOnCloseModal: PropTypes.func,
    handleOnAddStudentSubmit: PropTypes.func,
    intl: intlShape.isRequired,
    isSaveInProgress: PropTypes.bool,
    selectedProduct: PropTypes.object,
    showAddStudentValidationModal: PropTypes.bool,
    student: PropTypes.object,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    getClassroomGroups: PropTypes.func,
    classroomGroups: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(styleable(css)(AddStudent));




// WEBPACK FOOTER //
// ./app/components/add-student/index.js